import { colord } from 'colord'
export const setAlpha = (color,alpha = 1)=>{
  let a = +alpha
  if(typeof  a === 'number'){
    if(a < 0){
      a = 0
    }else if( a > 1){
      a = 1
    }
  }else{
    a = 1
  }
  const c = colord(color);
  if(c.isValid()){
    return c.alpha(a).toRgbString();
  }else{
    return  color
  }
}

export const getAlpha = (color)=>{
  const c = colord(color);
  if(c.isValid()){
    return c.alpha();
  }else{
    return  color
  }
}

